import "./Header.scss";
import pedra from "../../assets/images/logo-png/pedras1.png";
import logo from "../../assets/images/logo-png/ret2.png";
import fixedLogo from "../../assets/images/logo-png/letras.png";
import capaVideo from "../../assets/videos/capa_v3.mp4";
import MenuSlider from "./MenuSlider";
import { useEffect, useRef, useState } from "react";
import { handleClickSchedule } from "Helper";

const Header: React.FC = () => {
  const divRef = useRef<HTMLDivElement>(null);
  const [isAtTop, setIsAtTop] = useState(false);

  const handleScroll = () => {
    if (divRef.current) {
      const rect = divRef.current.getBoundingClientRect();
      const isAtTop = rect.bottom <= 120;
      setIsAtTop(isAtTop);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    const video = divRef.current?.querySelector("video");
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Se falhar, pode mostrar um botão de play manual aqui
          console.warn("Autoplay falhou");
        });
      }
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const showHeaderContainer = () => {
    return (
      <>
        <div ref={divRef} className="video-container">
          <video src={capaVideo} autoPlay loop muted playsInline preload="auto" />

          <div className="nav-links">
            <nav>
              <a href="#aboutUs">Sobre</a>
              <a href="#services">Serviços</a>
              <a href="#contact">Contato</a>
            </nav>
          </div>

          <div className="content">
            <img
              src={logo}
              alt="Kerolyn Terapeuta Corporal"
              className={`${isAtTop ? "scrolled" : ""}`}
            />

            <p className="slogan">
              Massagens e técnicas terapêuticas para corpo, mente e energia.
            </p>

            <div className="agende">
              <a className="button" id="schedule-now" onClick={handleClickSchedule}>
                Agende Já
              </a>
              
            </div>
          </div>
        </div>
      </>
    );
  };

  const showHeaderFixed = () => {
    return (
      <div className={`headerContainerFixed ${isAtTop ? "visible" : ""}`}>
        <div className="logo">
          <img className="pedras" src={pedra} alt="Kerolyn Terapeuta Corporal" />
          <img className="fixo" src={fixedLogo} style={{height: "55px"}} alt="Kerolyn Terapeuta Corporal" />
        </div>
        {/* <div className="logo">
          
        </div> */}
        <nav>
          <div className="nav-links">
            <a href="#aboutUs">Sobre</a>
            <a href="#services">Serviços</a>
            <a href="#requestQuote">Contato</a>
          </div>
        </nav>
      </div>
    );
  };

  return (
    <>
      {showHeaderContainer()}
      {showHeaderFixed()}

      <MenuSlider />
    </>
  );
};

export default Header;
